module.exports = __webpack_public_path__ + "static/media/st.f48819e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/st.svg
// module id = 254
// module chunks = 0